import { takeLatest } from 'redux-saga/effects';
import { fetchEntitySpawn } from 'store/saga';
import URLHelper from './transactions.api';
import {
  FETCH_TRANSACTIONS,
  PATCH_TRANSACTION,
  POST_BATCH,
  fetchTransactions,
  SUBMIT_OTP,
  submit_otp,
  RESEND_OTP,
  resend_otp,
  patchTransaction,
  postBatch,
} from './transactions.actions';
import { REQUEST } from 'utils/actionGenerator';

function* getTransactionsSaga(action: any) {
  const request = URLHelper.getTransactions(action.params);
  yield fetchEntitySpawn(request, fetchTransactions, action.params);
}

function* patchTransactionSaga(action: any) {
  const request = URLHelper.patchTransaction(action.params);
  yield fetchEntitySpawn(request, patchTransaction, action.params);
}

function* postBatchSaga(action: any) {
  const request = URLHelper.postBatch(action.params);
  yield fetchEntitySpawn(request, postBatch, action.params);
}

function* submitOtpSaga(action: any) {
  const request = URLHelper.submitOtp(action.params);
  yield fetchEntitySpawn(request, submit_otp, action.params);
}

function* resendOtpSaga(action: any) {
  const request = URLHelper.resendOtp(action.params);
  yield fetchEntitySpawn(request, resend_otp, action.params);
}

function* TransactionsSaga() {
  yield takeLatest(FETCH_TRANSACTIONS[REQUEST], getTransactionsSaga);
  yield takeLatest(PATCH_TRANSACTION[REQUEST], patchTransactionSaga);
  yield takeLatest(POST_BATCH[REQUEST], postBatchSaga);
  yield takeLatest(SUBMIT_OTP[REQUEST], submitOtpSaga);
  yield takeLatest(RESEND_OTP[REQUEST], resendOtpSaga);
}

export default TransactionsSaga;
